import React from "react";
import { Space, Tooltip, Typography } from "antd";
import {
  agingSignalColor,
  eligibilitySignalColor,
  labelAging,
  labelEligibility,
} from "views/breakage/breakage-labels";
import { themeColors, themeText } from "theme";

const { Text } = Typography;

const Dot = ({ color, label }) => (
  <Tooltip title={label}>
    <span
      role="img"
      aria-label={label}
      style={{
        display: "inline-block",
        width: 10,
        height: 10,
        borderRadius: "50%",
        background: color,
        flexShrink: 0,
        boxShadow: `0 0 0 1px ${color}33`,
      }}
    />
  </Tooltip>
);

const LegendItem = ({ color, label }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      marginRight: 14,
      marginBottom: 4,
    }}
  >
    <span
      style={{
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: color,
        flexShrink: 0,
      }}
    />
    <Text
      style={{
        fontSize: 11,
        color: themeColors.grayColor,
        fontFamily: themeText.fontFamily,
        lineHeight: 1.2,
      }}
    >
      {label}
    </Text>
  </span>
);

export const BreakageStatusSignal = ({ eligibility, agingCondition }) => {
  const eligibilityLabel = labelEligibility(eligibility);
  const agingLabel = labelAging(agingCondition);

  return (
    <Space size={6} style={{ justifyContent: "center" }}>
      <Dot
        color={eligibilitySignalColor[eligibility] || themeColors.grayColor}
        label={`Resgate: ${eligibilityLabel}`}
      />
      <Dot
        color={agingSignalColor[agingCondition] || themeColors.grayColor}
        label={`Prazo: ${agingLabel}`}
      />
    </Space>
  );
};

export const BreakageStatusLegend = () => (
  <div
    style={{
      marginTop: 10,
      paddingTop: 8,
      borderTop: `1px solid ${themeColors.disabledColor}`,
    }}
  >
    <Text
      style={{
        display: "block",
        fontSize: 11,
        fontWeight: themeText.medium,
        color: themeColors.mediumColor,
        marginBottom: 6,
        fontFamily: themeText.fontFamily,
      }}
    >
      Legenda da situação
    </Text>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "2px 0" }}>
      <LegendItem
        color={eligibilitySignalColor.ELIGIBLE}
        label="Elegível para Breakage"
      />
      <LegendItem
        color={eligibilitySignalColor.INELIGIBLE}
        label="Não elegível"
      />
      <LegendItem color={agingSignalColor.EXPIRED} label="Vencido" />
      <LegendItem color={agingSignalColor.WITHIN_WINDOW} label="A vencer" />
    </div>
  </div>
);
